import axiosConfig from '../utils/axiosConfigInstance';

export const userVideosApi = {
	getRecommendedVideoData: (videoId, options = {}) => axiosConfig.post('/fetch/videos/data', { videoId }, options),

	getRecommendedStudioVideoData: (videoId, playlistId, options = {}) =>
		axiosConfig.get(`/studio-playlist/${playlistId}/${videoId}`, options),

	getRecommendedFeatureVideoData: (videoId, playlistId, options = {}) =>
		axiosConfig.get(`/featurevideo/${playlistId}/${videoId}`, options),

	getRecommendedPersonalVideoData: (videoId, playlistId, options = {}) =>
		axiosConfig.get(`/personalvideo/${playlistId}/${videoId}`, options)
};
